module.exports = __webpack_public_path__ + "media/instrucation.bc2f1a12.mp4";